import {Container, Graphics, Text} from "pixi.js";
import {round} from "./utils.js";
import {Vector} from "./i.js";
import {UIUtils} from "./i.js";

export class Debugger {
	constructor(game) {
		this.game = game;

		this.display = new Container();

		this.averageFPS = [];
		this.averageMSPT = [];
		this.lastTickStart = null;
		this.lastDensities = new Map();

		this._background = new Graphics();
		this.text = new Text("hi", UIUtils.getFont(0xffffff));
		this.display.addChild(this._background, this.text);

		this.display.visible = false;
	}

	update(screenSize) {
		if (!this.display.visible) return;

		let rulerLength = UIUtils.getRulerLength(screenSize);

		this.text.position.copyFrom(new Vector(
			0.02 * rulerLength,
			0.02 * rulerLength
		).round());
		this.text.style.fontSize = 0.02 * rulerLength;

		let averageFPSDisplay = this.averageFPS.length === 0
			? 1
			: Math.round(
				this.averageFPS.reduce((a, b) => a + b) / this.averageFPS.length
			);
		let averageMSPTDisplay = this.averageMSPT.length === 0
			? 1000
			: this.averageMSPT.reduce((a, b) => a + b) / this.averageMSPT.length;
		let numThings = this.game.space.things.length;
		let numCollisionCooldowns = this.game.space.interactor._collisionCooldowns.size;

		let densityDisplay = Array.from(this.lastDensities.entries())
			.map(entry => `${entry[0].toLowerCase()}: ${round(entry[1], 2)}`)
			.join("\n");

		this.text.text = `fps:  ${averageFPSDisplay}`
			+ `\nmspt:  ${round(averageMSPTDisplay, 3)}`
			+ `\nfps limit:  ${Math.floor(1000 / averageMSPTDisplay)}`
			+ `\nthings:  ${numThings}`
			+ `\ncooldowns:  ${numCollisionCooldowns}`
			+ "\n"
			+ "\ndensity"
			+ `\n${densityDisplay}`;

		let backgroundOrigin = new Vector(0.01 * rulerLength, 0.01 * rulerLength).round();
		let backgroundSize = new Vector(
			this.text.width + 0.02 * rulerLength,
			this.text.height + 0.02 * rulerLength
		).round();
		this._background
			.clear()
			.rect(
				backgroundOrigin.x, backgroundOrigin.y,
				backgroundSize.x, backgroundSize.y
			)
			.fill({color: 0x000000, alpha: 0.6});
	}

	// Toggle the debugger between visible and invisible
	toggle() {
		this.display.visible = !this.display.visible;
	}

	// Report the start of a tick
	// Call as early in the tick as possible.
	reportTickStart() {
		this.lastTickStart = performance.now();
	}

	// Report the end of a tick
	// Call as late in the tick as possible.
	reportTickEnd() {
		if (this.lastTickStart !== null) {
			this.averageMSPT.unshift(performance.now() - this.lastTickStart);
			if (this.averageMSPT.length > 256) this.averageMSPT.pop();
			this.lastTickStart = null;
		}
	}

	// Report time between frames
	// Args:
	//   dt - time from last frame to this frame, in seconds
	reportDt(dt) {
		let fps = 1 / dt;
		this.averageFPS.unshift(fps);
		if (this.averageFPS.length > 256) this.averageFPS.pop();
	}

	// Report current densities
	// Args:
	//   densities: map from Density.POOLS to floats
	reportDensities(densities) {
		this.lastDensities = new Map(densities);
	}
}
